<template>
  <div>
    <DxForm ref="formInstance" :form-data="model" label-location="top" :show-colon-after-label="false"
      validation-group="validacionClienteInmobiliario" class="mt-4">
      <DxColCountByScreen :xs="6" :sm="6" :md="6" :lg="6" />

      <DxGroupItem :col-count="6" :col-span="6">

        <DxSimpleItem :col-span="6">
          <span class="dx-field-item-label-text text-success">{{$t('clienteInmobiliario.form.datosPersonales')}}</span>
        </DxSimpleItem>

        <DxGroupItem :col-count="6" :col-span="6">
          <!-- Selector de tipo de persona -->
          <DxSimpleItem data-field="TipoPersona" editor-type="dxSelectBox" :col-span="2"
            :editor-options="getDomainEnumSelectBox('tipo_persona', 'values')">
            <DxLabel :text="$t('tipo_persona.label')" />
            <DxRequiredRule :message="$t('tipo_persona.validations.required')" />
          </DxSimpleItem>
          <DxEmptyItem :col-span="4" />

          <!-- Datos de persona juridica -->
          <DxSimpleItem data-field="RazonSocial" editor-type="dxTextBox" :col-span="2" :visible="esPersonaJuridica"
            :editor-options="uppercaseTextBoxOptions">
            <DxLabel :text="$t('wizard.step4.nombre_razon_social')" />
            <DxRequiredRule :message="$t('wizard.step4.validacion.nombre_razon_social')" />
          </DxSimpleItem>
          <DxSimpleItem data-field="CIF" editor-type="dxTextBox" :col-span="2" :visible="esPersonaJuridica"
            :editor-options="uppercaseTextBoxOptions">
            <DxLabel :text="$t('wizard.step4.cif')" />
            <DxRequiredRule :message="$t('wizard.step4.validacion.cif')" />
            <DxPatternRule :pattern="cifPattern" :message="$t('wizard.step4.validacion.cif_patron')" />
          </DxSimpleItem>
          <DxSimpleItem data-field="SubtipoPersona" editor-type="dxSelectBox" :col-span="2" :visible="esPersonaJuridica"
            :editor-options="getDomainEnumSelectBox('subtipo_persona', 'values')">
            <DxLabel :text="$t('subtipo_persona.label')" />
            <DxRequiredRule :message="$t('subtipo_persona.validations.required')" />
          </DxSimpleItem>
          <DxSimpleItem :col-span="6" :visible="esPersonaJuridica">
            <span class="dx-field-item-label-text text-success">{{
              $t("wizard.step4.persona_juridica_label")
            }}</span>
          </DxSimpleItem>
        </DxGroupItem>

      <!-- Datos personales -->

      <DxSimpleItem data-field="Documento" editor-type="dxTextBox" :col-span="2" :editor-options="uppercaseTextBoxOptions">
        <DxLabel :text="$t('clienteInmobiliario.documento')" />
        <DxRequiredRule :message="$t('clienteInmobiliario.validations.documento')" />
        <DxPatternRule :pattern="dniNieNifPattern" :message="$t('clienteInmobiliario.validations.dni_nie_patron')" />
      </DxSimpleItem>

      <DxSimpleItem data-field="Nombre" :col-span="2">
        <DxLabel :text="$t('clienteInmobiliario.nombre')" />
        <DxRequiredRule :message="$t('clienteInmobiliario.validations.nombre')" />
      </DxSimpleItem>

      <DxSimpleItem data-field="Apellidos" :col-span="2">
        <DxLabel :text="$t('clienteInmobiliario.apellidos')" />
        <DxRequiredRule :message="$t('clienteInmobiliario.validations.apellidos')" />
      </DxSimpleItem>
      
      <DxSimpleItem data-field="Email" :col-span="2">
        <DxLabel :text="$t('clienteInmobiliario.email')" />
        <DxRequiredRule :message="$t('clienteInmobiliario.validations.email')" />
        <DxEmailRule :message="$t('clienteInmobiliario.validations.email_patron')" />
      </DxSimpleItem>

      <DxSimpleItem data-field="TelFijo" :col-span="2" :editor-options="telefonoOptions('Fijo')">
        <DxLabel :text="$t('clienteInmobiliario.telFijo')" />
      </DxSimpleItem>

      <DxSimpleItem data-field="TelMovil" :col-span="2" :editor-options="telefonoOptions('Movil')">
        <DxLabel :text="$t('clienteInmobiliario.telMovil')" />
        <DxRequiredRule :message="$t('clienteInmobiliario.validations.telefono')" />
      </DxSimpleItem>
    </DxGroupItem>

    <DxGroupItem :col-count="6" :col-span="6">
      <!-- Datos de pago -->
      <DxSimpleItem :col-span="6">
        <span class="dx-field-item-label-text text-success">{{$t('clienteInmobiliario.form.datosPago')}}</span>
      </DxSimpleItem>

      <DxSimpleItem
        data-field="IbanPago"
        editor-type="dxTextBox"
        :col-span="3"
        :editor-options="ibanOptions"
      >
        <DxLabel :text="$t('iban.ui.label')" />
        <DxPatternRule :pattern="ibanPattern" :message="$t('iban.ui.validations.pattern')" />
      </DxSimpleItem>

      <DxSimpleItem :col-span="3">
        <DxRadioGroup v-model="datosPagoIguales" v-bind="yesNoOptions"/>
        <DxLabel :text="$t('clienteInmobiliario.ui.datosPagoIguales')" />
      </DxSimpleItem>
    </DxGroupItem>

      <DxGroupItem :col-count="6" :col-span="6">
        <DxSimpleItem data-field="TipoDocumentoPago" editor-type="dxSelectBox" :col-span="2" :visible="!datosPagoIguales"
          :editor-options="{...getDomainEnumSelectBox('tipoDocumento', 'values')}">
          <DxLabel :text="$t('clienteInmobiliario.tipoDocumento')" />
        </DxSimpleItem>

        <DxSimpleItem data-field="DocumentoPago" editor-type="dxTextBox" :col-span="2" :visible="!datosPagoIguales"
          :editor-options="uppercaseTextBoxOptions">
          <DxLabel :text="$t('clienteInmobiliario.documentoPago')" />
        </DxSimpleItem>

        <DxEmptyItem :col-span="2" />

        <DxSimpleItem data-field="NombrePago" :col-span="2" :visible="!datosPagoIguales">
          <DxLabel :text="$t('clienteInmobiliario.nombrePago')" />
        </DxSimpleItem>

        <DxSimpleItem data-field="ApellidosPago" :visible="model?.TipoDocumentoPago === TipoDocumentoEnum.Nif && !datosPagoIguales" :col-span="2">
          <DxLabel :text="$t('clienteInmobiliario.apellidosPago')" />
        </DxSimpleItem>
        <DxEmptyItem :col-span="2" />
      </DxGroupItem>
    </DxForm>
  </div>
</template>

<script setup lang="ts">
import { ref, watch, onBeforeMount, computed } from 'vue';
import { DxForm, DxSimpleItem, DxGroupItem, DxEmptyItem, DxLabel, DxColCountByScreen, DxRequiredRule, DxPatternRule, DxEmailRule } from "devextreme-vue/form";
import { DxRadioGroup } from 'devextreme-vue';
import { getDomainEnumSelectBox } from '@helpers/grid-helper';
import { useApi } from '@api/integration';
import validationEngine from "devextreme/ui/validation_engine";
import { useIntl } from '@services/i18n';
import { CreateClienteInmobiliario } from './models/CreateClienteInmobiliario';
import { EditClienteInmobiliario } from './models/EditClienteInmobiliario';
import { toastError, toastSuccess } from '@services/notification-service';
import { TipoDocumentoEnum, TipoPersonaEnum } from '@api/api';
import { useIbanField, useYesNoField } from '@composables/devextreme';
import { ApiError } from '@/.shared/services/http';
import { DUPLICATED_REAL_ESTATE_CLIENT_FISICA, DUPLICATED_REAL_ESTATE_CLIENT_JURIDICA } from '@/.shared/errors/codes';

interface Props {
  idClienteInmobiliario?: string;
  isEmbedded?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  isEmbedded: false
});

const emit = defineEmits(['cliente-saved']);
const api = useApi();
const intl = useIntl();
const model = ref<CreateClienteInmobiliario | EditClienteInmobiliario>(new CreateClienteInmobiliario());

const formInstance = ref<DxForm>();
const cifPattern = ref<RegExp>(/^[A-Z]\d{7}[A-Z0-9]$|^\d{8}[A-Z]$/);
const dniNieNifPattern = ref<RegExp>(/^(?:\d{8}[A-Z]|[XYZ]\d{7}[A-Z]|[A-Z0-9]{5,9})$/);

const convertirMayusculas = (e: { value?: string; component: { option: (name: string, value: string | undefined) => void } }) => {
  const upperValue = e.value?.toUpperCase();
  e.component.option("value", upperValue);
};

const uppercaseTextBoxOptions = {
  inputAttr: { class: "uppercase-text" },
  onValueChanged: convertirMayusculas
};

const aMayusculasIdentificadores = (cliente: CreateClienteInmobiliario | EditClienteInmobiliario) => {
  if (cliente.Documento) cliente.Documento = cliente.Documento.toUpperCase();
  if (cliente.CIF) cliente.CIF = cliente.CIF.toUpperCase();
  if (cliente.DocumentoPago) cliente.DocumentoPago = cliente.DocumentoPago.toUpperCase();
};


const datosPagoIguales = ref(true);

const { ibanPattern, getIbanFieldOptions } = useIbanField();
const ibanOptions = getIbanFieldOptions();

const { getYesNoOptions } = useYesNoField();
const yesNoOptions = getYesNoOptions();

const calcularDatosPagoIguales = () => {
  if (!model.value) return true;
  
  if (model.value.TipoPersona === TipoPersonaEnum.Fisica) {
    return model.value.Nombre === model.value.NombrePago &&
           model.value.Apellidos === model.value.ApellidosPago &&
           model.value.Documento === model.value.DocumentoPago;
  } else {
    return model.value.RazonSocial === model.value.NombrePago &&
           model.value.CIF === model.value.DocumentoPago;
  }
};

const telefonoOptions = (fieldName: string) => ({
  mask: "+34 000 000 000",
  maskChar: "_",
  maskInvalidMessage: intl.i18n.t('wizard.step4.validacion.telefono_patron'),
  name: fieldName,
  useMaskedValue: true,
  onValueChanged: (e:any) => { if (fieldName === 'Movil') {
      model.value.TelMovil = e.value?.toUpperCase().replace(/ /g, "").replace(/^\+34/, "")
    } else {
      model.value.TelFijo = e.value?.toUpperCase().replace(/ /g, "").replace(/^\+34/, "")
    }
  }
});

const esPersonaJuridica = computed(() => {
  return model.value.TipoPersona && model.value.TipoPersona == TipoPersonaEnum.Juridica;
});

onBeforeMount(async () => {
  if (props.idClienteInmobiliario) {
    const detailCliente = await api.callStandardApi("getClienteInmobiliarioById", { showLoading: true }, props.idClienteInmobiliario);
    model.value = new EditClienteInmobiliario().createFromDetailClienteInmobiliario(detailCliente);
    aMayusculasIdentificadores(model.value);
    datosPagoIguales.value = calcularDatosPagoIguales();
  } else {
  }
});

const isValid = () => {
  return validationEngine.validateGroup("validacionClienteInmobiliario").isValid;
};

const saveOrEdit = async (): Promise<boolean> => {
  if (isValid()) {
    try {
      aMayusculasIdentificadores(model.value);
      model.value.TelFijo = model.value.TelFijo ? (model.value.TelFijo.startsWith('+34') ? model.value.TelFijo : `+34${model.value.TelFijo}`) : null;
      model.value.TelMovil = model.value.TelMovil ? (model.value.TelMovil.startsWith('+34') ? model.value.TelMovil : `+34${model.value.TelMovil}`) : null;

      if (model.value.TipoDocumentoPago == null) 
          model.value.TipoDocumentoPago = model.value.TipoPersona === TipoPersonaEnum.Fisica ? TipoDocumentoEnum.Nif : TipoDocumentoEnum.Cif;

      let idCliente;
      try {
        if (props.idClienteInmobiliario) {
          await api.callStandardApi("editClienteInmobiliario", { showLoading: true }, model.value as EditClienteInmobiliario);
          idCliente = props.idClienteInmobiliario;
        } else {
          idCliente = await api.callStandardApi("createClienteInmobiliario", { showLoading: true }, model.value as CreateClienteInmobiliario);
        }
      } catch (e: any) {
        if (e instanceof ApiError && e.details?.errorList.length === 1 && [DUPLICATED_REAL_ESTATE_CLIENT_FISICA, DUPLICATED_REAL_ESTATE_CLIENT_JURIDICA].includes(e.details.errorList[0].Code)) {
          toastError(intl.i18n.t(`shared.errors.api.${e.details.errorList[0].Code}`));
          return false;
        }
        throw e;
      }

      // Si está embebido, emitimos el evento con el ID del cliente
      if (props.isEmbedded) {
        emit('cliente-saved', idCliente);
      }
      
      toastSuccess(intl.i18n.t('clienteInmobiliario.ui.guardado'));
      return true;
    } catch (error) {
      toastError(intl.i18n.t('clienteInmobiliario.ui.fallo_guardar'));
      return false;
    }
  }
  return false;
}

// Watcher para cuando el usuario cambia manualmente el radio
watch(datosPagoIguales, (newValue) => {
  if (newValue && model.value) {
    model.value.TipoDocumentoPago = model.value.TipoPersona === TipoPersonaEnum.Juridica ? TipoDocumentoEnum.Cif : TipoDocumentoEnum.Nif;
    model.value.NombrePago = model.value.TipoPersona === TipoPersonaEnum.Fisica ? model.value.Nombre ?? null : model.value.RazonSocial ?? null;
    model.value.DocumentoPago = model.value.TipoPersona === TipoPersonaEnum.Fisica ? model.value.Documento ?? null : model.value.CIF ?? null;
    model.value.ApellidosPago = model.value.TipoPersona === TipoPersonaEnum.Fisica ? model.value.Apellidos ?? null : null;
  }
});

// Watchers para actualizar los datos de pago cuando cambian los datos del cliente
watch(() => model.value?.Nombre, (newValue) => {
  if (datosPagoIguales.value && model.value && model.value.TipoPersona === TipoPersonaEnum.Fisica) {
    model.value.NombrePago = newValue ?? null;
  }
});

watch(() => model.value?.RazonSocial, (newValue) => {
  if (datosPagoIguales.value && model.value && model.value.TipoPersona === TipoPersonaEnum.Juridica) {
    model.value.NombrePago = newValue ?? null;
  }
});

watch(() => model.value?.Documento, (newValue) => {
  if (datosPagoIguales.value && model.value && model.value.TipoPersona === TipoPersonaEnum.Fisica) {
    model.value.DocumentoPago = newValue ?? null;
  }
});

watch(() => model.value?.CIF, (newValue) => {
  if (datosPagoIguales.value && model.value && model.value.TipoPersona === TipoPersonaEnum.Juridica) {
    model.value.DocumentoPago = newValue ?? null;
  }
});

watch(() => model.value?.Apellidos, (newValue) => {
  if (datosPagoIguales.value && model.value && model.value.TipoPersona === TipoPersonaEnum.Fisica) {
    model.value.ApellidosPago = newValue ?? null;
  }
});

watch(() => model.value?.TipoPersona, (newValue) => {
  if (newValue === TipoPersonaEnum.Fisica) {
    model.value.RazonSocial = null;
    model.value.CIF = null;
    model.value.SubtipoPersona = null;

    if (datosPagoIguales.value) {
      model.value.TipoDocumentoPago = TipoDocumentoEnum.Nif;
      model.value.NombrePago = model.value.Nombre;
      model.value.DocumentoPago = model.value.Documento;
      model.value.ApellidosPago = model.value.Apellidos;
    }
  }
  if (newValue === TipoPersonaEnum.Juridica && datosPagoIguales.value) {
    model.value.TipoDocumentoPago = TipoDocumentoEnum.Cif;
    model.value.NombrePago = model.value.RazonSocial;
    model.value.DocumentoPago = model.value.CIF;
    model.value.ApellidosPago = null;
  }
});


defineExpose({
  isValid,
  saveOrEdit
});
</script>

<style scoped lang="scss">
.uppercase-text {
  text-transform: uppercase;
}
</style>
